
import React, { ReactElement } from "react";
import { CartDeliveryStatus, DeliveryMethod, getSelectedDeliveryFromDeliveryStatus, getWholeCartDeliveryStatus } from "../../../logic/shipping-logic";
import { CartItem } from "../../../types/models/mvcapi";
import { HorizontalButtonSelector } from "../../../../jsxctl/utilctl";
import { UUID } from "../../../types/basetypes";
import { SelectedDeliveryMethod } from "../../organisms";
import { EMPTY_UUID } from "../../../logic";
const tstranslate = require('ts-translate-js').default;

const tr = tstranslate.boundTR;

export type CartDeliverySelectorProps = {
    delivStatus: CartDeliveryStatus;
    forceDeliveryMethod: (method: DeliveryMethod, shippingFeeId?: UUID) => void;
    cartLoaded: boolean;
    mailDeliveryMessage: string
}

export function CartDeliverySelector({delivStatus, forceDeliveryMethod, cartLoaded, mailDeliveryMessage}: CartDeliverySelectorProps): ReactElement {
    const selectedShippingMethodToUse = getSelectedDeliveryFromDeliveryStatus(delivStatus);
    
    const shippingButtonsDef = [];
    if(delivStatus.isEticketDeliveryAvailable)
        shippingButtonsDef.push({ text: tr("ordervalidation.seteticketdelivery"), onClick: () => forceDeliveryMethod(DeliveryMethod.ETICKET), selected: selectedShippingMethodToUse === DeliveryMethod.ETICKET });
    
    if(delivStatus.isBoxOfficeAvailable)
        shippingButtonsDef.push({ text: tr("Je récupérerai mes billets au guichet"), onClick: () => forceDeliveryMethod(DeliveryMethod.BOX_OFFICE), selected: selectedShippingMethodToUse === DeliveryMethod.BOX_OFFICE });
    
    if(delivStatus.isMailDeliveryAvailable) {
        // If there's only one mail delivery rating, we can show different possibilities to the user.
        if(delivStatus.shippingFeesSignatures.length === 1) { 
            delivStatus.shippingFees.forEach((sf) => {
                const name = tsapp.twoLetterLang === "en" ? sf.NameEn : sf.NameFr;
                let selected = 
                    (selectedShippingMethodToUse === DeliveryMethod.MAIL && sf.MethodId === delivStatus.mostUsedShippingFeeID) // If it is the currently selected shipping method
                    ||
                    (selectedShippingMethodToUse === DeliveryMethod.MAIL && sf.MethodId === EMPTY_UUID && delivStatus.mostUsedShippingFeeID == null); // If the method is Empty_Guid and there is no mostUsedShippingFeeID but still is in DeliveryMethod.MAIL, it means that the user has selected the default mail delivery method.

                shippingButtonsDef.push({ text: name, onClick: () => forceDeliveryMethod(DeliveryMethod.MAIL, sf.MethodId), selected: selected });
            });

        } else // Else, just show the "mail" delivery option.
            // TODO: Test that
            shippingButtonsDef.push({ text: tr("ordervalidation.setmaildelivery"), onClick: () => forceDeliveryMethod(DeliveryMethod.MAIL), selected: selectedShippingMethodToUse === DeliveryMethod.MAIL });
    }

    let mailDeliveryMessageSection;
    if(cartLoaded && mailDeliveryMessage != null && mailDeliveryMessage != "")
        mailDeliveryMessageSection =
            <div className="row">
                <div className="col-md-12">
                    <div className="alert alert-warning clearfix">
                        <div className="col-xs-1">
                            <i className="fa fa-exclamation-circle fa-3x" aria-hidden="true"/>
                        </div>
                        <div className="col-xs-11"><span>{mailDeliveryMessage}</span></div>
                    </div>
                </div>
            </div>;

    return (
        <div style={{marginBottom: 20}}>
            <h4>{tr("Récupération de votre commande")}</h4>
            <p>{tr("Veuillez sélectionner la méthode de récupération")}</p>
            <div className="row">
                <HorizontalButtonSelector buttons={shippingButtonsDef} className="col-md-12" />
            </div>
            {selectedShippingMethodToUse === DeliveryMethod.MAIL ? mailDeliveryMessageSection : null}
        </div>
    );
}

export type WholeCartDeliverySelectorProps = {
    cartItems: CartItem[];
    forceDeliveryMethod: (method: DeliveryMethod, shippingFeeId?: UUID) => void;
    cartLoaded: boolean;
    mailDeliveryMessage: string;
}


export function WholeCartDeliverySelector({cartItems, forceDeliveryMethod, cartLoaded, mailDeliveryMessage}: WholeCartDeliverySelectorProps) {
    const delivStatus = getWholeCartDeliveryStatus(cartItems);
    return <CartDeliverySelector 
        delivStatus={delivStatus}
        forceDeliveryMethod={forceDeliveryMethod}
        cartLoaded={cartLoaded}
        mailDeliveryMessage={mailDeliveryMessage}
    />;
}


export type OrderProductsDeliverySelectorProps = {
    forceDeliveryMethod: (method: DeliveryMethod, shippingFeeId?: UUID) => void;
    mailDeliveryMessage?: string;
    selectedShippingMethod?: SelectedDeliveryMethod;
    delivStatus: CartDeliveryStatus;
}

export function OrderProductsDeliverySelector({delivStatus, forceDeliveryMethod, mailDeliveryMessage}: OrderProductsDeliverySelectorProps) {
    return <CartDeliverySelector 
        delivStatus={delivStatus}
        forceDeliveryMethod={forceDeliveryMethod}
        cartLoaded
        mailDeliveryMessage={mailDeliveryMessage}
    />;
}